import { GetterTree } from 'vuex';
import { SimuladorState } from './state';
import { RootState } from '../types';

export const getters: GetterTree<SimuladorState, RootState> = {
    resultadoSimulacion: (state) => state.resultado
};